import { ModalManager } from "@circle-react/components/Layout/ModalManagerProvider";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { WorkflowsMomentumModal } from "@/react/components/WorkflowsMomentumModal";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { useReportModal } from "./ReportModal";

const COMMENT_FLAGGED_CONTENTABLE_TYPE = "Comment";

export const useReportHandler = ({ comment }) => {
  const { id } = comment;
  const { success, error } = useToast();
  const reportModal = useReportModal();
  const { currentCommunityMember } = usePunditUserContext();
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");

  const { mutate: submitReport } = useMutation({
    mutationFn: formData =>
      reactQueryPost(internalApi.flaggedContent.create(), {
        flagged_content: {
          ...formData,
          flagged_contentable_id: id,
          flagged_contentable_type: COMMENT_FLAGGED_CONTENTABLE_TYPE,
        },
      }),
    onSuccess: () => {
      success(t("comments.report.alerts.success"), {
        duration: "short",
        shouldUseProgress: false,
      });
      void reportModal.hide().then(() => reportModal.remove());

      if (isCommunityAdmin(currentCommunityMember)) {
        void ModalManager.show(WorkflowsMomentumModal, {
          templateKey: "ai_moderate_new_comments",
        });
      }
    },
    onError: () => {
      error(t("comments.report.alerts.failure"));
    },
  });

  const openReportModal = () => {
    if (isCircleV4) {
      void reportModal.show({ commentId: id });
      return;
    }

    void reportModal.show({ onReportSubmit: submitReport });
  };

  return {
    openReportModal,
  };
};
